<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header" style="color: #8cc63e"><b>คำสั่งซื้อ {{ order_header.order_code }} </b></div>
            <div v-if="order_header.customer_paylater == 0">
              <div v-if="order_header.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
              <div v-else-if="order_header.status === 1 && order_header.payment_status === 0" class="padding_header"
                style="color: black"><b>สถานะ :</b> <b style="color: grey">รอการลูกค้าชำระเงิน</b></div>
              <div
                v-else-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 0 && order_header.payment_type === 1"
                class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #fdac39">รอตรวจสอบการชำระเงิน</b></div>
              <div
                v-else-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 1 || order_header.payment_type === 2"
                class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #fdac39">ดำเนินการจัดสินค้า</b>
              </div>
              <div
                v-else-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 2"
                class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #fdac39">ดำเนินการจัดสินค้า</b>
              </div>
              <div v-else-if="order_header.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #8cc63e">เสร็จสิ้น</b></div>
              <div
                v-else-if="order_header.status === 3 && order_header.payment_status === 1 && order_header.slip_status === 2"
                class="padding_header" style="color: black"><b>สถานะ :</b> <b style="color: red">ยกเลิกคำสั่งซื้อ</b>
              </div>
            </div>
            <div v-if="order_header.customer_paylater == 1">
              <div v-if="order_header.status === 0" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #8cc63e">คำสั่งซื้อใหม่</b></div>
              <div v-else-if="order_header.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: grey">ดำเนินการจัดสินค้า</b></div>

              <div v-else-if="order_header.status === 4" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #fdac39">รอยืนยัน</b></div>
              <div v-else-if="order_header.status === 5" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                  style="color: #fdac39">
                  <span v-if="order_header.payment_status === 0" style="color: #000">ส่งของเสร็จแล้วรอลูกค้าจ่ายเงิน
                  </span>
                  <!-- <span v-else-if="order_header.payment_status === 1 && order_header.slip_status === 1 || order_header.payment_type === 2" style="color: #fdac39">ดำเนินการจัดสินค้า</span> -->
                  <span v-else-if="order_header.payment_status === 1 && order_header.slip_status === 0"
                    style="color: #fdac39">รอตรวจสอบการชำระเงิน</span>
                  <span v-else-if="order_header.payment_status === 1 && order_header.slip_status === 2"
                    style="color: red">การชำระเงินไม่ถูกต้อง</span>
                </b></div>
            </div>

          </div>
          <div class="grid_sub_half">
            <div v-if="order_header.status === 4">
              <div v-if="order_header.payment_type === 3" class="padding_header" style="color: black"><b>{{
      order_header.track_number }}</b></div>
              <div v-else class="padding_header" style="color: black"><b>หมายเลขแทร็กกิ้ง : </b> <b
                  style="color: black">{{ order_header.track_number }}</b></div>
            </div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกค้า</b> <span v-if="order_header.tax_invoice !== 0"
                style="color: #8CC63E;">(รับใบกำกับภาษี)</span></div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ชื่อลูกค้า : </div>
              <div class="ml-1 mr-3">{{ order_header.name }}</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">ที่อยู่จัดส่ง : </div>
              <div v-if="order_header.delivery_type !== 1" class="ml-1 mr-3">{{ order_header.address }}</div>
              <div v-else class="ml-1 mr-3">รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)</div>
            </div>
            <div class="grid_flex mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : </div>
              <div v-if="order_header.telephone !== null" class="ml-1 mr-3">{{ order_header.telephone }}</div>
              <div v-else class="ml-1 mr-3">-</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img" v-if="order_header.customer_paylater == 0">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div v-if="order_header.payment_type !== null" class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div v-if="order_header.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="order_header.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <!-- <div v-else-if="order_header.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div> -->
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <!-- <div v-if="order_header.delivery_type !== 1" class="ml-1 mr-3">{{ format_price(total + parseFloat(order_header.delivery_price)) }} บาท</div>
                  <div v-else class="ml-1 mr-3">{{ format_price(total) }} บาท</div> -->
                  <div class="ml-1 mr-3">{{ format_price(order_header.total_price) }} บาท</div>
                </div>
                <div v-if="order_header.slip_status === 1" class="mt-2" style="color: #8cc63e">
                  <div>ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">ผู้ตรวจสอบ :</div>
                    <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                  </div>
                </div>
                <div v-if="order_header.slip_status === 2" class="mt-2" style="color: red;">
                  <div>หลักฐานการโอนเงินไม่ถูกต้อง</div>
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                    <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                  </div>
                </div>
                <div v-if="order_header.payment_type != 2">
                  <div class="mt-2 display_pc"
                    v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 0">
                    <v-btn elevation="5" @click="image_modal = true"
                      class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                  </div>
                  <div class="mt-2 btn_flex"
                    v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 2">
                    <v-btn elevation="5" @click="image_addon = true"
                      class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                    <v-btn elevation="5" @click="cancel_order = true"
                      class="pa-6 mt-1 mobile_btn rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                  </div>
                  <div class="mt-2 display_pc"
                    v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 0">
                    <v-btn elevation="5" @click="image_modal = true"
                      class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                  </div>
                  <div class="mt-2 btn_flex"
                    v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 2">
                    <v-btn elevation="5" @click="image_addon = true"
                      class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                    <v-btn elevation="5" @click="cancel_order = true"
                      class="pa-6 mt-1 mobile_btn rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                  </div>

                </div>
              </div>
              <div v-if="order_header.payment_type != 2">
                <div
                  v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 1"
                  class="mx-auto">
                  <v-img v-if="order_header.slip_picture !== null" @click="show_img" class="mx-auto rounded cursor_img"
                    height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="order_header.slip_picture"></v-img>
                  <v-img v-else class="mx-auto rounded cursor_img" height="160" width="160" max-width="160"
                    :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
                </div>
                <div class="mx-auto"
                  v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 0">
                  <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                    max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                    @click="show_img"></v-img>
                  <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="picture_not_found"></v-img>
                </div>
                <div class="mx-auto"
                  v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 2">
                  <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                    max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                    @click="show_img"></v-img>
                  <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="picture_not_found"></v-img>
                </div>
                <div class="mx-auto"
                  v-if="order_header.status === 3 && order_header.payment_status === 1 && order_header.slip_status === 2">
                  <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                    max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                    @click="show_img"></v-img>
                  <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="picture_not_found"></v-img>
                </div>
                <div class="mx-auto" v-if="order_header.status === 2">
                  <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                    max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                    @click="show_img"></v-img>
                  <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="picture_not_found"></v-img>
                </div>

                <div class="mx-auto" v-if="order_header.status === 4">
                  <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                    max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                    @click="show_img"></v-img>
                  <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                    :src="picture_not_found"></v-img>
                </div>

                <div class="mt-2 display_mobile"
                  v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 0">
                  <v-btn elevation="5" @click="image_modal = true"
                    class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                </div>
                <div class="mt-2 display_mobile"
                  v-if="order_header.status === 1 && order_header.payment_status === 1 && order_header.slip_status === 2">
                  <v-btn elevation="5" @click="image_addon = true"
                    class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                  <v-btn elevation="5" @click="cancel_order = true"
                    class="pa-6 mt-1 mobile_btn rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                </div>

                <div class="mt-2 display_mobile"
                  v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 0">
                  <v-btn elevation="5" @click="image_modal = true"
                    class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                </div>
                <div class="mt-2 display_mobile"
                  v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 2">
                  <v-btn elevation="5" @click="image_addon = true"
                    class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                  <v-btn elevation="5" @click="cancel_order = true"
                    class="pa-6 mt-1 mobile_btn rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                </div>

              </div>
            </div>
            <div class="grid_img" v-if="order_header.customer_paylater == 1">
              <div>
                <div class=""><b>การชำระเงิน</b></div>
                <div v-if="order_header.payment_type !== null" class="d-flex mt-2">
                  <div class="ml-1 mr-3">ชำระผ่าน : </div>
                  <div v-if="order_header.payment_type === 1" class="ml-1 mr-3">โอนเงิน</div>
                  <div v-else-if="order_header.payment_type === 2" class="ml-1 mr-3">ติดเครดิต</div>
                  <!-- <div v-else-if="order_header.payment_type === 3" class="ml-1 mr-3">รับสินค้าหน้าร้าน</div> -->
                </div>
                <div class="d-flex mt-2">
                  <div class="ml-1 mr-3">ยอดชำระ : </div>
                  <!-- <div v-if="order_header.delivery_type !== 1" class="ml-1 mr-3">{{ format_price(total + parseFloat(order_header.delivery_price)) }} บาท</div>
                  <div v-else class="ml-1 mr-3">{{ format_price(total) }} บาท</div> -->
                  <div class="ml-1 mr-3">{{ format_price(order_header.total_price) }} บาท</div>
                </div>
                <div v-if="order_header.slip_status === 1" class="mt-2" style="color: #8cc63e">
                  <div>ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">ผู้ตรวจสอบ :</div>
                    <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                  </div>
                </div>
                <div v-if="order_header.slip_status === 2" class="mt-2" style="color: red;">
                  <div>หลักฐานการโอนเงินไม่ถูกต้อง</div>
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                    <div class="ml-1 mr-3">{{ order_header.user_confirm_name }}</div>
                  </div>
                </div>
                <div v-if="order_header.payment_type != 2">
                  <div class="mt-2 display_pc"
                    v-if="order_header.status === 5 && order_header.payment_status === 1 && order_header.slip_status === 0">
                    <v-btn elevation="5" @click="image_modal = true"
                      class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                  </div>
                  <div class="mt-2 btn_flex"
                    v-if="order_header.status === 5 && order_header.payment_status === 1 && order_header.slip_status === 2">
                    <v-btn elevation="5" @click="image_addon = true"
                      class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                  </div>
                  <!-- <div class="mt-2 display_pc"
                    v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 0">
                    <v-btn elevation="5" @click="image_modal = true"
                      class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                  </div>
                  <div class="mt-2 btn_flex"
                    v-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 2">
                    <v-btn elevation="5" @click="image_addon = true"
                      class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                    <v-btn elevation="5" @click="cancel_order = true"
                      class="pa-6 mt-1 mobile_btn rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                  </div> -->

                </div>
              </div>
              <div v-if="order_header.customer_paylater == 1">
                <div v-if="order_header.payment_type != 2">
                  <div
                    v-if="order_header.status === 5 && order_header.payment_status === 1 && order_header.slip_status === 1"
                    class="mx-auto">
                    <v-img v-if="order_header.slip_picture !== null" @click="show_img"
                      class="mx-auto rounded cursor_img" height="160" width="160" max-width="160"
                      :lazy-src="picture_not_found" :src="order_header.slip_picture"></v-img>
                    <v-img v-else class="mx-auto rounded cursor_img" height="160" width="160" max-width="160"
                      :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
                  </div>
                  <div class="mx-auto"
                    v-if="order_header.status === 5 && order_header.payment_status === 1 && order_header.slip_status === 0">
                    <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                      max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                      @click="show_img"></v-img>
                    <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                      :src="picture_not_found"></v-img>
                  </div>
                  <div class="mx-auto"
                    v-if="order_header.status === 5 && order_header.payment_status === 1 && order_header.slip_status === 2">
                    <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                      max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                      @click="show_img"></v-img>
                    <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                      :src="picture_not_found"></v-img>
                  </div>
                  <div class="mx-auto"
                    v-if="order_header.status === 2 && order_header.payment_status === 1 && order_header.slip_status === 1">
                    <v-img v-if="order_header.slip_picture !== null" class="rounded" height="160" width="160"
                      max-width="160" :lazy-src="picture_not_found" :src="order_header.slip_picture"
                      @click="show_img"></v-img>
                    <v-img v-else class="rounded" height="160" width="160" max-width="160" :lazy-src="picture_not_found"
                      :src="picture_not_found"></v-img>
                  </div>
                </div>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการสินค้า</b></div>
              <v-divider />
              <v-data-table class="border_table" :headers="header" :items="data_list" :items-per-page="perPage"
                hide-default-footer mobile-breakpoint="0">
                <template v-slot:item="dataDetail">
                  <!-- product ที่ไม่ยกเลิก -->
                  <tr v-if="dataDetail.item.product_cancel !== 1">
                    <td class="border_table pa-3">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" v-if="dataDetail.item.product_picture !== null" height="120"
                          width="120" max-width="120" :lazy-src="picture_product"
                          :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" v-else height="120" width="120" max-width="120"
                          :lazy-src="picture_product" :src="picture_product"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div>{{ dataDetail.item.product_name }}<br>
                        <b :class="{ 'primary--text': parseInt(dataDetail.item.count_warehouse) >= dataDetail.item.count_min_unit, 'error--text': dataDetail.item.count_warehouse < dataDetail.item.count_min_unit }"
                          v-if="dataDetail.item.count_in_warehouse">จำนวนคงเหลือในคลัง :
                          {{ dataDetail.item.count_in_warehouse }}</b>
                      </div>
                      <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                        <small class="pl-3">- {{ data.name }} ({{ data.qty }} {{ data.unit_name }})</small>
                        <br>
                        <small class="pl-5 primary--text" v-if="data.count_in_warehouse"><b>จำนวนคงเหลือในคลัง : {{
      data.count_in_warehouse }}</b></small>
                      </div>
                    </td>
                    <td class="border_table text-center">{{ format_number(dataDetail.item.cost) }}</td>
                    <td class="border_table text-center">
                      <s v-if="dataDetail.item.old_qty !== null && dataDetail.item.qty !== dataDetail.item.old_qty"
                        class="red--text">{{ dataDetail.item.old_qty }}</s> <s
                        v-if="dataDetail.item.old_unit_name !== null && dataDetail.item.old_unit_name !== dataDetail.item.unit_name"
                        class="red--text">{{ dataDetail.item.old_unit_name
                        }}</s> {{ dataDetail.item.qty }} {{ dataDetail.item.unit_name }}
                    </td>
                    <td class="border_table text-center">{{ format_price(dataDetail.item.total) }}</td>
                  </tr>
                  <!-- product ที่ยกเลิก -->
                  <tr v-else>
                    <td class="border_table pa-3">
                      <div class="mx-auto">
                        <v-img class="mx-auto rounded" v-if="dataDetail.item.product_picture !== null" height="120"
                          width="120" max-width="120" :lazy-src="picture_not_found"
                          :src="dataDetail.item.product_picture"></v-img>
                        <v-img class="mx-auto rounded" v-else height="120" width="120" max-width="120"
                          :lazy-src="picture_holder" :src="picture_not_found"></v-img>
                      </div>
                    </td>
                    <td class="border_table pa-3">
                      <div><s class="red--text">{{ dataDetail.item.product_name }}</s></div>
                      <div v-for="(data, index) in dataDetail.item.product_list" :key="index">
                        <small class="pl-3"><s class="red--text">- {{ data.name }} ({{ data.qty }} {{ data.unit_name
                            }})</s></small>
                      </div>
                    </td>
                    <td class="border_table text-center"><s class="red--text">{{ format_number(dataDetail.item.cost)
                        }}</s></td>
                    <td class="border_table text-center"><s
                        v-if="dataDetail.item.old_quantity !== null && dataDetail.item.qty !== dataDetail.item.old_quantity"
                        class="py-3 red--text">{{ dataDetail.item.old_quantity }}</s> <s class="py-3 red--text">{{
      dataDetail.item.qty }} {{ dataDetail.item.unit_name }}</s></td>
                    <td class="border_table text-center"><s class="red--text">{{ format_price(dataDetail.item.total)
                        }}</s></td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>ค่าจัดส่ง</b></td>
                    <td v-if="order_header.delivery_type == 3" class="border_table text-center"><b>{{
      format_price(order_header.delivery_price) }}</b></td>
                    <td v-else class="border_table text-center"><b>0.00</b></td>
                  </tr>
                  <tr>
                    <td colspan="4" class="border_table text-right mr-3"><b>รวมทั้งหมด</b></td>
                    <!-- <td v-if="order_header.delivery_type !== 1" class="border_table text-center"><b>{{ result_total = format_price(total + parseFloat(result_weight)) }}</b></td>
                    <td v-else class="border_table text-center"><b>{{ result_total = format_price(total) }}</b></td> -->
                    <td class="border_table text-center"><b>{{ format_price(order_header.total_price) }}</b></td>

                  </tr>
                </template>
              </v-data-table>
              <div class="mt-4" >
                <v-btn large elevation="5" style="font-size: 18px" v-if="order_header.status === 0"
                  class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill" @click="print_send_order">
                  <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
                </v-btn>
                <!-- <v-btn large elevation="5" @click="print_tax_invoice(order_header.name, order_header.delivery_address)"
                  style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
                  <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
                </v-btn> -->
              </div>
            </div>
          </v-card>
          <div class="text-center pa-5 mb-3" >
            <v-btn large elevation="5" style="font-size: 18px" @click="get_edit" v-if="order_header.status === 0"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขคำสั่งซื้อ
            </v-btn>
            <v-btn large elevation="5" style="font-size: 18px" @click="confirm_order" v-if="order_header.status === 0"
              class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-check-bold</v-icon> อนุมัติคำสั่งซื้อ
            </v-btn>

            <v-btn large elevation="5" @click="order_edit" style="font-size: 18px" v-if="order_header.status === 1"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
            </v-btn>
            <v-btn large elevation="5" @click="print_send_order" style="font-size: 18px" v-if="order_header.status === 1 || order_header.status === 2"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>

            <v-btn large elevation="5" @click="print_tax_invoice(order_header.name, order_header.address)"
              style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn>
          </div>
          <div class="mt-3"
            v-if="order_header.status === 3 && order_header.payment_status === 1 && order_header.slip_status === 2">
            <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
              <div class="pa-5">
                <div class="mt-2 mb-4"><b>การยกเลิกคำสั่งซื้อ</b></div>
                <div class="mt-4 red--text">
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">ผู้ยกเลิก :</div>
                    <div class="ml-1 mr-3">{{ order_header.user_confirm_name }} {{ order_header.confirm_date }}</div>
                  </div>
                  <div class="grid_flex">
                    <div class="ml-1 mr-3">เหตุผล :</div>
                    <div class="ml-1 mr-3">{{ order_header.cancel_note }}</div>
                  </div>
                </div>
              </div>
            </v-card>
          </div>

          <div class="text-center pa-5 mb-3"
            v-else-if="order_header.status === 4 && order_header.payment_status === 1 && order_header.slip_status === 1">
            <v-btn large elevation="5" @click="order_edit" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-warning-bg white--text rounded-pill">
              <v-icon>mdi-pencil-outline</v-icon> แก้ไขใบจัดของ
            </v-btn>
            <v-btn large elevation="5" @click="print_send_order" style="font-size: 18px"
              class="mobile_grid ml-1 mr-1 pa-6 grad-main-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์เอกสารส่งสินค้า
            </v-btn>

            <v-btn large elevation="5" @click="print_tax_invoice(order_header.name, order_header.delivery_address)"
              style="font-size: 18px" class="mobile_grid ml-1 mr-1 pa-6 grad-success-bg white--text rounded-pill">
              <v-icon>mdi-printer-outline</v-icon> พิมพ์ใบกำกับภาษี
            </v-btn>
          </div>
        </div>
        <v-dialog v-model="tax_invoice_show" max-width="600">
          <v-card>
            <v-form ref="tax_invoice_save" @submit.prevent="tax_invoice_save">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ข้อมูลลูกค้า</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="tax_invoice_show = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-text-field type="text" color="#86bc3a" label="ชื่อลูกค้า" v-model="data_tax_invoice.name"
                      prepend-inner-icon="mdi-account-outline" :rules="[v => !!v || 'กรุณากรอกชื่อลูกค้า']"
                      hide-details="auto" required outlined>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="ที่อยู่จัดส่ง" v-model="data_tax_invoice.delivery_address"
                      :rules="[v => !!v || 'กรุณากรอกที่อยู่จัดส่ง']" hide-details="auto" required outlined>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="เลขเสียภาษี" type="tel" maxlength="13"
                      @keypress="isTaxNumber($event, order_header.tax_number)"
                      :rules="[v => !!v || 'กรุณากรอกเลขเสียภาษี']"
                      prepend-inner-icon="mdi-card-account-details-outline" hide-details="auto"
                      v-model="order_header.tax_number" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field color="#86bc3a" label="รหัสสาขา" type="text"
                      @keypress="isNumber($event, order_header.branch)"
                      :rules="[v => !!v || 'กรุณากรอกรหัสสาขา']" hide-details="auto"
                      v-model="order_header.branch" outlined required>
                    </v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <div class="pa-1 text-right mt-5">
                      <v-btn x-large type="submit" class="grad-success-bg white--text"
                        style="font-size: 18px" @click="printOriginalTaxInvoice(status_read)">พิมพ์ใบกำกับภาษีตัวจริง</v-btn>
                    </div>
                  </v-col>
                  <v-col cols="6">
                    <div class="pa-1 text-left mt-5">
                      <v-btn x-large type="submit" class="grad-warning-bg white--text"
                        style="font-size: 18px" @click="printCopyTaxInvoice(status_copy)">พิมพ์ใบกำกับภาษีสำเนา</v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Upload Picture -->
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image" @submit.prevent="">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ format_price(order_header.total_price) }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img v-if="order_header.slip_picture !== null" class="mx-auto rounded" height="auto" width="300"
                    max-width="300" :lazy-src="picture_not_found" :src="order_header.slip_picture"></v-img>
                  <v-img v-else class="mx-auto rounded" height="300" width="300" max-width="300"
                    :lazy-src="picture_not_found" :src="picture_not_found"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail"
                    class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct"
                    class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Show Picture -->
        <v-dialog v-model="preview_modal" max-width="512">
          <div v-if="loading_img === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
              <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <v-card>
              <v-form ref="cancel" @submit.prevent="">
                <div class="d-flex justify-space-between">
                  <v-card-title>
                    หลักฐานการชำระเงิน
                  </v-card-title>
                  <v-btn icon class="ma-4" @click="preview_modal = false">
                    <v-icon color="grey">mdi-close</v-icon>
                  </v-btn>
                </div>
                <v-card-text>
                  <div class="" v-for="(data, index) in this.slip_img" :key="index">
                    <div class="pa-1 mt-2">
                      <v-img max-width="360" v-if="data.slip_picture !== null" :lazy-src="picture_not_found"
                        :src="data.slip_picture" class="mx-auto"></v-img>
                      <v-img max-width="360" v-else :lazy-src="picture_not_found" :src="picture_not_found"
                        class="mx-auto"></v-img>
                    </div>
                    <div class="text-center pt-2" style="color: #8cc63e">ผู้อัพโหลด : {{ data.from }}</div>
                  </div>
                </v-card-text>
              </v-form>
            </v-card>
          </div>
        </v-dialog>
        <!-- Add Picture -->
        <v-dialog v-model="image_addon" max-width="520">
          <v-card>
            <v-form ref="image" @submit.prevent="upload_addon">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  อัพโหลดหลักฐานการโอนเงินเพิ่มเติม
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_addon = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-4">
                    <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_not_found"
                      :src="picture_not_found" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :lazy-src="picture_not_found"
                      :src="imagePreviewURL" class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input prepend-icon="mdi-image" color="#86bc3a" accept="image/*" label="อัพโหลด"
                    :rules="[v => !!v || 'กรุณาอัพโหลดไฟล์']" v-model="addon_file"
                    @change="onFileChange"></v-file-input>
                  <div>การอัพโหลดหลักฐานเพิ่มเติมจาก Admin จะทำการยืนยันหลักฐาน อัตโนมัติ</div>
                  <div class="mt-6">
                    <v-btn x-large v-if="imagePreviewURL == null" class="rounded-pill white--text grad-grey-bg btn_size"
                      disabled>อัพโหลด</v-btn>
                    <v-btn type="submit" x-large v-if="imagePreviewURL !== null"
                      class="rounded-pill white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Cancel Order -->
        <v-dialog v-model="cancel_order" max-width="700">
          <v-card>
            <v-form ref="cancel" @submit.prevent="save_cancel">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  ยกเลิกคำสั่งซื้อ
                </v-card-title>
                <v-btn icon class="ma-4" @click="cancel_order = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="mb-5" style="font-size: 20px">คุณต้องการยกเลิกคำสั่งซื้อของลูกค้าเพราะเหตุใด ?</div>
                  <v-text-field color="#86bc3a" label="กรุณากรอกเหตุผลการยกเลิกออเดอร์" v-model="cancel_note"
                    :rules="[v => !!v || 'กรุณากรอกเหตุผลการยกเลิกออเดอร์']" hide-details="auto"
                    outlined></v-text-field>
                </div>
                <div class="text-center mt-4">
                  <v-btn x-large type="submit" class="rounded-pill white--text grad-danger-bg ">ยกเลิกคำสั่งซื้อ</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { formatNumber, formatPrice } from "@/js/handler";
import picture_holder from "@/assets/picture.png";
import picture_not_found from "@/assets/image-not-found.png";
import picture_product from "@/assets/pill.png";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Order_customer_detail",
  data() {
    return {
      loading_page: false,
      loading_img: false,
      image_addon: false,
      cancel_order: false,
      addon_file: null,
      imagePreviewURL: null,
      picture_holder: picture_holder,
      picture_not_found: picture_not_found,
      picture_product: picture_product,
      preview_modal: false,
      perPage: -1,
      image_modal: false,
      overlay: false,
      weight_all: 0,
      result_weight: 0,
      result_total: 0,
      order_number: '',
      cancel_note: '',
      status_read: 'read',
      status_copy: 'copy',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header: [
        {
          text: 'รูป',
          value: 'product_img',
          align: 'center',
          sortable: false,
          fixed: true,
          width: '160px',
        },
        {
          text: 'รายการสินค้า',
          value: 'product_name',
          align: 'left',
          fixed: true,
          width: '500px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: 'price_unit',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          align: 'center',
          fixed: true,
          width: '180px',
        },
        {
          text: 'ราคารวม',
          value: 'total',
          align: 'center',
          fixed: true,
          width: '180px',
        },
      ],
      data_list: [],
      order_header: [],
      slip_img: [],
      tax_invoice_show: false,
      data_tax_invoice: {
        name: null,
        delivery_address: null,
        tax_number: null,
        branch_code: null,
      }
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.addon_file = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.addon_file = null
          }
        }
      } else {
        this.imagePreviewURL = null
        this.addon_file = null
      }
    },
    async get_data() {
      this.loading_page = true
      await HTTP.post('wholesales/orderdetail', {
        id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.order_header = res.data.order_head
          this.data_list = res.data.order_list
          res.data.order_list.forEach((data) => {
            this.weight_all += data.qty * parseFloat(data.weight)
          })
          this.get_price_rate(this.weight_all)
        }
      })
    },
    async get_price_rate(weight) {
      let get_weight = this.format_price(weight)
      let math_weight = Math.ceil(get_weight)
      let weight_arr = []
      await HTTP.get('wholesales/price_rate')
        .then((res) => {
          if (res.data.success === true) {
            res.data.price_rate.forEach((data) => {
              weight_arr.push({
                id: data.id,
                rate_end: data.rate_end !== null ? data.rate_end : '0.00',
                rate_price: data.rate_price,
                rate_start: data.rate_start !== null ? data.rate_start : '0.00',
                rate_type: data.rate_type,
              })
            })
            let result_weight = weight_arr.find((data) => (math_weight >= parseFloat(data.rate_start)))
            this.result_weight = result_weight.rate_price
          }
        })
    },
    confirm_order() {
      Swal.fire({
        text: 'คุณต้องดำเนินการต่อหรือไม่ ?',
        icon: 'warning',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `ตกลง`,
        denyButtonText: `ยกเลิก`,
      }).then((res) => {
        if (res.isConfirmed === true) {
          this.overlay = true
          HTTP.post('wholesales/approve', {
            order_id: this.$route.params.id
          }).then((res) => {
            if (res.data.success === true) {
              this.overlay = false
              this.$router.push('/sell/ordercustomermain')
            }
            else {
              this.overlay = false
              Swal.fire({
                text: 'ไม่สำเร็จ !',
                icon: 'error',
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: `ตกลง`,
                denyButtonText: `ยกเลิก`,
              })
            }
          })
        }
      })
    },
    get_edit() {
      const id = this.$route.params.id
      this.$router.push('/sell/ordercustomeredit/' + id)
    },
    show_img() {
      this.preview_modal = true
      this.loading_img = true
      HTTP.post('/wholesales/allslips', {
        order_id: this.$route.params.id,
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_img = false
          this.slip_img = res.data.object
        }
      })
    },
    confirm_detail() {
      this.overlay = true
      HTTP.post('wholesales/confirmslip', {
        order_id: this.order_header.id,
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.image_modal = false
          this.get_data()
        }
      })
    },
    in_correct() {
      this.overlay = true
      HTTP.post('wholesales/cancelslip', {
        order_id: this.order_header.id,
        user_id: this.$store.state.userDetail.id,
        user_name: this.$store.state.userDetail.name,
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.image_modal = false
          this.get_data()
        }
      })
    },
    upload_addon() {
      if (this.$refs.image.validate()) {
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.addon_file.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.addon_file = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip_upload', this.addon_file, this.addon_file.name)
          formData.append('order_id', this.order_header.id)
          formData.append('user_id', this.$store.state.userDetail.id)
          formData.append('user_name', this.$store.state.userDetail.name)
          this.overlay = true
          HTTP.post('/wholesales/attachslip', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.image_addon = false
                this.addon_file = null
                this.alert_success = true
                setTimeout(() => this.alert_success = false, 1000)
                this.get_data()
              }
            })
        }
      }
    },
    save_cancel() {
      if (this.$refs.cancel.validate()) {
        Swal.fire({
          title: 'ต้องการยกเลิกคำสั่งซื้อหรือไม่ ?',
          icon: 'warning',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        }).then((res) => {
          if (res.isConfirmed === true) {
            this.overlay = true
            HTTP.post('/wholesales/cancel', {
              order_id: this.order_header.id,
              user_id: this.$store.state.userDetail.id,
              user_name: this.$store.state.userDetail.name,
              cancel_note: this.cancel_note,
            }).then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.cancel_order = false
                this.cancel_note = ''
                this.get_data()
              }
            })
          }
          else {
            this.cancel_note = ''
          }
        })
      }
    },
    order_edit() {
      const id = this.$route.params.id
      this.$router.push('/sell/ordercustomereditlots/' + id)
    },
    print_send_order() {
      if (this.order_header.delivery_type !== 1) {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/envelopewholesale/' + this.order_header.order_code, '_blank')
      }
      else {
        window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + this.order_header.order_code, '_blank')
        window.open('https://www.pharmacare-plus.com/packingslipwholesale/' + this.order_header.order_code, '_blank')
      }
    },
    print_tax_invoice(name, delivery_address) {
      this.data_tax_invoice.name = name
      this.data_tax_invoice.delivery_address = delivery_address
      // window.open('http://192.168.1.161:8000/taxinvoice/' + this.order_header.order_code + '?data=' + this.data_tax_invoice, '_blank')
      this.tax_invoice_show = true;
    },
    tax_invoice_save(status) {
      let status_result = status
      let data = {
        customer_name: this.data_tax_invoice.name,
        delivery_address: this.data_tax_invoice.delivery_address,
        tax_number: this.order_header.tax_number,
        branch_code: this.order_header.branch,
        status_data: status_result,
        user_id: this.$store.state.userDetail.id
      }
      if (this.$refs.tax_invoice_save.validate()) {
        return data;
      }
      return null;
    },

    printOriginalTaxInvoice(status) {
      const data = this.tax_invoice_save(status);
      if (data) {
        window.open('https://www.pharmacare-plus.com/taxinvoicewholesale/' + this.order_header.order_code + '?data=' + JSON.stringify(data), '_blank')
      }
    },

    printCopyTaxInvoice(status) {
      const data = this.tax_invoice_save(status);
      if (data) {
        window.open('https://www.pharmacare-plus.com/taxinvoicewholesale/' + this.order_header.order_code + '?data=' + JSON.stringify(data), '_blank')
      }
    }
  },
  computed: {
    total() {
      let data_arr = [];
      this.data_list.forEach((data) => {
        if (data.product_cancel !== 1) {
          data_arr.push(data)
        }
      })
      const result = data_arr.reduce((sum, number) => {
        let total_price = number.cost * number.qty
        if (total_price < 0) {
          return sum + (0)
        }
        else {
          return sum + (total_price);
        }
      }, 0)
      return result;
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}

.cursor_img {
  cursor: pointer;
}

.rounded_card {
  border-radius: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.btn_flex {
  display: flex !important;
}

.grid_img {
  display: grid;
  grid-template-columns: 70% 30%;
}

.border_table {
  border: #e0e0e0 solid 1px
}

.mobile_btn {
  width: 50%;
}

.display_pc {
  display: block;
}

.display_mobile {
  display: none;
}

.mobile_grid {
  width: 25%
}

.btn_size {
  width: 100%;
}

@media only screen and (max-width: 1180px) {
  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_grid {
    width: 32%
  }
}

@media only screen and (max-width: 500px) {
  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }

  .grid_mx {
    margin: auto;
  }

  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_btn {
    width: 100%;
  }

  .btn_flex {
    display: none !important;
  }

  .display_pc {
    display: none;
  }

  .display_mobile {
    display: block;
  }
}
</style>
